export default "__VITE_ASSET__DnCM2lzw__"